import React, { useEffect, useState } from "react";
import { usePlatformAuth } from "context/PlatformAuthContext";
import { platformApiService } from "services/platformApi";
import { useNavigate } from "react-router-dom";

const PlatformSubscriptions: React.FC = () => {
 const { isAuthenticated } = usePlatformAuth();
 const navigate = useNavigate();
 const [subscriptions, setSubscriptions] = useState<any[]>([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!isAuthenticated) {
   navigate("/platform/login", { replace: true });
   return;
  }

  fetchSubscriptions();
 }, [isAuthenticated, navigate]);

 const fetchSubscriptions = async () => {
  try {
   const response = await platformApiService.getSubscriptions();
   setSubscriptions(response.data.subscriptions || []);
  } catch (error) {
   console.error("Error fetching subscriptions:", error);
  } finally {
   setLoading(false);
  }
 };

 if (loading) {
  return <div className="p-8">Loading subscriptions...</div>;
 }

 return (
  <div className="p-8">
   <div className="mb-6">
    <h1 className="text-3xl font-bold">Subscriptions</h1>
    <p className="text-gray-600 mt-2">
     Manage store subscriptions. To create a subscription for a store, go to the store detail page.
    </p>
   </div>
   <div className="bg-white shadow overflow-hidden">
    <table className="min-w-full divide-y divide-gray-200">
     <thead className="bg-gray-50">
      <tr>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Store
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Plan
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Status
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Billing Cycle
       </th>
       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
        Period
       </th>
       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
        Actions
       </th>
      </tr>
     </thead>
     <tbody className="bg-white divide-y divide-gray-200">
      {subscriptions.map((sub) => (
       <tr key={sub._id} className="hover:bg-gray-50">
        <td className="px-6 py-4 whitespace-nowrap">
         <button
          onClick={() => navigate(`/platform/stores/${(sub.storeId as any)?._id || sub.storeId}`)}
          className="text-indigo-600 hover:text-indigo-900 font-medium"
         >
          {(sub.storeId as any)?.name || "N/A"}
         </button>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
         <div className="flex flex-col gap-1">
          <span>{(sub.planId as any)?.name || "N/A"}</span>
          {sub.hasScheduledChanges && sub.scheduledPlanId && (
           <span className="text-xs text-blue-600 font-medium">
            → {(sub.scheduledPlanId as any)?.name || "New Plan"} (scheduled)
           </span>
          )}
         </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
         <div className="flex flex-col gap-1">
          <span
           className={`px-2 inline-flex text-xs leading-5 font-semibold ${
            sub.status === "active"
             ? "bg-green-100 text-green-800"
             : "bg-red-100 text-red-800"
           }`}
          >
           {sub.status}
          </span>
          {sub.hasScheduledChanges && (
           <span className="px-2 inline-flex text-xs leading-5 font-semibold bg-blue-100 text-blue-800">
            Changes Scheduled
           </span>
          )}
         </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         {sub.billingCycle}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
         {new Date(sub.currentPeriodStart).toLocaleDateString()} -{" "}
         {new Date(sub.currentPeriodEnd).toLocaleDateString()}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
         <button
          onClick={() => navigate(`/platform/stores/${(sub.storeId as any)?._id || sub.storeId}`)}
          className="text-indigo-600 hover:text-indigo-900"
         >
          Manage
         </button>
        </td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default PlatformSubscriptions;

